import { EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
var EmailStepComponent = /** @class */ (function () {
    function EmailStepComponent() {
        this.toPasswordStep = new EventEmitter();
    }
    return EmailStepComponent;
}());
export { EmailStepComponent };
